module.exports = __webpack_public_path__ + "static/media/ico-arrow-left-light.ed16b050.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Pagination/ico-arrow-left-light.svg
// module id = 291
// module chunks = 0